var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGzQuote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 106.23 89.766",
    enableBackground: "new 0 0 106.23 89.766",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,56.063c0-15.973,3.806-28.591,11.42-37.855C19.032,8.945,30.133,2.875,44.723,0v16.611 c-10.861,3.409-18.156,9.264-21.883,17.57c-1.916,4.368-2.715,8.892-2.396,13.577h25.077v42.008H0V56.063z M60.709,56.063 c0-16.185,3.914-28.855,11.74-38.015C80.275,8.892,91.269,2.875,105.432,0v16.611C94.676,19.913,87.435,25.875,83.71,34.5 c-2.132,4.58-2.982,9-2.556,13.257h25.076v42.008H60.709V56.063z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGzQuote);
export default __webpack_public_path__ + "static/media/GZ_quote.5f4287479353ac7fc96fedb2dd84d387.svg";
export { ForwardRef as ReactComponent };